module.exports = __webpack_public_path__ + "img/repair_active_red.4340cbcd.svg";